import { render } from "./VDraggable.vue?vue&type=template&id=5686b6ef&ts=true"
import script from "./VDraggable.vue?vue&type=script&lang=ts"
export * from "./VDraggable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__